export const fetchLandingPageData = async (): Promise<string> => {
  try {
    const response = await fetch("/v1/public/tickets");
    const data = await response.json();
    if (!Array.isArray(data)) return "Tidak ditemukan data tiket.";
    let tickets: string[] = [];
    data.forEach((ticket: any) => {
      const name = ticket.title || ticket.name || "";
      const price = ticket.price ? `Rp${ticket.price}` : "";
      const type = ticket.type === "fast-track" ? "Fast Track" : "Reguler";
      tickets.push(`Nama: ${name}, Harga: ${price}, Tipe: ${type}`);
    });
    let result = "";
    if (tickets.length > 0) {
      result += `Tiket tersedia:\n${tickets.join("\n")}`;
    }
    const exploreTicket = data.find((t: any) => t.title?.toLowerCase().includes("explore"));
    if (exploreTicket) {
      result += `\n\nExplore the Wonders: ${exploreTicket.description || ""}`;
    }
    return result || "Tidak ditemukan data tiket.";
  } catch (error) {
    return "";
  }
};
